import React from 'react'
import { IconButton } from "@material-ui/core";
import { AddSharp, RemoveSharp } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

function FiltersExpandCollapseButton(props) {
  const { isMenuExpanded, label, transformLabel = true } = props;

  let convertLabelUppercase = "";
  if (transformLabel) convertLabelUppercase = "label-transform";

  return (
    <div style={{ zIndex: "3", position: "relative" }}>
      <IconButton
        color="inherit"
        onClick={(e) => props.expandOrCollapseMenu(e)}
        style={{ background: "none", outline: 0 }}
      >
        <span className={"filters-menu-label " + convertLabelUppercase}>
          {isMenuExpanded ? (
            <RemoveSharp
              className="mr-3 rounded-sm"
              style={{ border: "2px solid #2c3687" }}
            />
          ) : (
            <AddSharp
              className="mr-3 rounded-sm"
              style={{ border: "2px solid #2c3687" }}
            />
          )}
          <FormattedMessage id={label} defaultMessage={label} />
        </span>
        {props.children && props.children}
      </IconButton>
    </div>
  );
}

export default FiltersExpandCollapseButton;
